// extracted by mini-css-extract-plugin
export var childrenContainer = "_b4-0";
export var virtualScrollArea = "_b4-1";